import axios from "axios";
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import TextTruncate from "react-text-truncate";
import LabelImportantRoundedIcon from "@material-ui/icons/LabelImportantRounded";
import AddShoppingCartRoundedIcon from "@material-ui/icons/AddShoppingCartRounded";
import ShoppingCartRoundedIcon from "@material-ui/icons/ShoppingCartRounded";
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import BookmarkRoundedIcon from "@material-ui/icons/BookmarkRounded";
import { useParams, useLocation ,useHistory} from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { useStateValue } from "../context/StateProvider";
import { shuffleArray } from "../utils/onLoad";
import './SingleProduct.scss'
import Product from "./Product";

function SingleProduct() {
  const { id } = useParams();
  const location = useLocation();
  const history = useHistory();


  const [productDetails, setProductDetails] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [ {cart,wishlist,products}, dispatch] = useStateValue();
  useEffect(() => {
    if (location.state && location.state.product) {
      setProductDetails(location.state.product);
      return;
    }
    const getProduct = async () => {
      try {
        const {data} = await axios.get("/products.json");
        const [productu] = data.filter((e) => e.id === id);
        setProductDetails(productu);
      } catch (error) {
        console.log(error);
      }
    };
    getProduct();
  }, [id, location.state]);
  useEffect(() => {
      console.log(products);
    if (products) {
      const suffArray=shuffleArray(products).slice(0,4);
      setSuggestions(suffArray.filter(e=>e.id !==id))
  }
}, [products,id]);
  const addToCart = (item) => {
    dispatch({
      type: "ADD_TO_CART",
      item: {
        ...productDetails,
        id: id,
        quantity: 1,
      },
    });
  };

  const addToWishlist = (item) => {
    dispatch({
      type: "ADD_TO_WISHLIST",
      item: {
        ...productDetails,
        id: id,
      },
    });
  };
  return (
    <div className="productSingle">
      <div className="productSingle__inner">
        <motion.div layoutId={id} className="productSingle__image">
          <img src={productDetails?.imgUrl} alt="" />
        </motion.div>
        <div className="productSingle__details">
          <TextTruncate
            line={3}
            element="h5"
            containerClassName="productSingle__name"
            truncateText="…"
            text={productDetails?.name}
          />
          <ul className="productSingle__features">
            {productDetails?.feature?.map((features,i) => (
              <li key={i}>{features}</li>
            ))}
          </ul>
          <span className="productSingle__footer">
            <h4 className="productSingle__price">
              <p className="">₹{productDetails?.price}</p>{" "}
              {productDetails?.discount && (
                <small>
                  <del>₹{productDetails?.originalPrice}</del>
                </small>
              )}
            </h4>
            
            {productDetails?.price > 5 && (
              <p className="productSingle__deliveryMessage">
                <LabelImportantRoundedIcon
                  style={{
                    fill: "transparent",
                    stroke: "currentColor",
                    strokeWidth: 1,
                    fontSize: 20,
                  }}
                />
                Free Delivery Available - Vidynagar, India 671123
              </p>
            )}
            <div className="buttons">
              {cart.filter(e=>e.id===id).length >0 ? (
                <button className="buttonPrimary" onClick={()=>history.push('/cart')}>
                  <ShoppingCartRoundedIcon /> Added <DoubleArrowIcon/>
                </button>
              ) : (
                <button className="buttonPrimary" onClick={addToCart}>
                  <AddShoppingCartRoundedIcon /> Add To Cart
                </button>
              )}
              <button
                data-tip={wishlist.filter(e=>e.id===id).length >0 ? "Remove" : "Wishlist"}
                data-for="wishlistTooltip"
                className="buttonSecondary"
                onClick={addToWishlist}
              >
                <BookmarkRoundedIcon
                  style={{
                    fill: wishlist.filter(e=>e.id===id).length >0 ? "green" : "#fff",
                    stroke: "#fff",
                    strokeWidth: 2,
                    fontSize: 20,
                  }}
                />
              </button>
              <ReactTooltip
                place="right"
                className="app__toolTip"
                id="wishlistTooltip"
                backgroundColor="#1a1a2cee"
                effect="solid"
              />
            </div>
          </span>
        </div>
      </div>
      <div className="productSingle__suggested">
        <h5 style={{ marginTop: "3rem", marginBottom: "1rem" }}>
          You might also like
        </h5>
            {console.log({suggestions})}
        <div className="products">
          {suggestions
            ?.slice(0, 3)
            .map((product) =>(
                <Product id={product.id} key={product.id} item={product} />
              ) 
            )}
        </div>
      </div>
    </div>
  );
}

export default SingleProduct;
